/** Readonly transaction mode */ const ReadOnly = "readonly";
/** Readwrite transaction mode */ const ReadWrite = "readwrite";
/** Mode for indexedDB transactions */ export const Mode = {
    ReadOnly: ReadOnly,
    ReadWrite: ReadWrite
};
export var IndexedDBErrors;
(function(IndexedDBErrors) {
    IndexedDBErrors["AbortError"] = "AbortError";
    IndexedDBErrors["ConstraintError"] = "ConstraintError";
    IndexedDBErrors["DataCloneError"] = "DataCloneError";
    IndexedDBErrors["DataError"] = "DataError";
    IndexedDBErrors["InvalidAccessError"] = "InvalidAccessError";
    IndexedDBErrors["InvalidStateError"] = "InvalidStateError";
    IndexedDBErrors["NotFoundError"] = "NotFoundError";
    IndexedDBErrors["QuotaExceededError"] = "QuotaExceededError";
    IndexedDBErrors["ReadOnlyError"] = "ReadOnlyError";
    IndexedDBErrors["TransactionInactiveError"] = "TransactionInactiveError";
    IndexedDBErrors["UnknownError"] = "UnknownError";
    IndexedDBErrors["VersionError"] = "VersionError";
    IndexedDBErrors["BlockedError"] = "BlockedError";
    IndexedDBErrors["NotReadableError"] = "NotReadableError";
})(IndexedDBErrors || (IndexedDBErrors = {}));
